import React, { useEffect, useRef, useState } from "react";
import { Definition } from "../../../../../../data/Definition";
import Stats from "../../../../components/Elements/Stats";
import Widget from "../../../../components/Elements/Widget";
import { useStore } from "../../../../providers/AppProvider";
import { Field, StatValue } from "../../../../types/types";
import { SETTING_SEASON_YEAR } from "../../../../utils/settings";
import { useGetAllZones } from '../../../../api/getAllZones';
import { Zone } from '../../../../types/types';
import { dcRound } from "../../../../utils/misc";
import _ from "lodash";

interface ZoneManagementBBCardProps {
    field: Field;
    setZones: Function;
    zones: Zone[] | null;
    selectedZoneName: string | null;
    setSelectedZoneName: Function;
    selectedZoneSetId: string | null;
    selectedZoneSetIndex: number;
    selectedDate: string | null;
    zoneData: any;
    setZoneData: Function;
}

const ZoneManagementBBCard = ({ field, setZones, zones, selectedZoneName, setSelectedZoneName, selectedZoneSetId, selectedZoneSetIndex, selectedDate, zoneData, setZoneData }: ZoneManagementBBCardProps) => {

    const [zonesData, setZonesData] = useState<any | null>(null);
    const [updateSelctorIncrement, setUpdateSelctorIncrement] = useState<number>(0);
    const [vigorValue, setVigorValue] = useState<any>(null);
    const [stressValue, setStressValue] = useState<any>(null);
    const [varValue, setVarValue] = useState<any>(null);
    const [changeValue, setChangeValue] = useState<any>(null);

    const { data: _zones } = useGetAllZones(field.id); 

    useEffect(() => {
        console.log("032924 _zones", _zones);
        console.log("032924 field", field);
        setZones(_zones);
        if (_zones && _zones.length > 0){
            let selectedIndex = 0;
            if (_zones[selectedZoneSetIndex]){
                selectedIndex = selectedZoneSetIndex;
            }//else{
            //    setSelectedZoneSetIndex(0);
            //}
            setZonesData(_zones[selectedIndex].geojson.features.sort((a:any, b:any) => {
                if (a.properties.label < b.properties.label) {
                return -1;
                }
                if (a.properties.label > b.properties.label) {
                return 1;
                }
                return 0; // If 'a' and 'b' are equal
            }));
        }else{
            setZonesData(null);
        }
    }, [_zones, selectedZoneSetIndex]);

    useEffect(() => {
        console.log("C040124 zoneData", zoneData);
        console.log("C040124 selectedDate", selectedDate);
        let tempStressValues = {};
        if (zoneData && zoneData?.stress?.dataAllZones && selectedDate) {
            zoneData.stress.dataAllZones.forEach((_zoneData:any) => {
                //console.log("B040124 _zoneData --> ", _zoneData);
                let selectedDateIndex = _zoneData?.row.stress_date.findIndex((date:string) => date.startsWith(selectedDate));
                //tempStressValues[_zoneData?.row.zone_name] = _zoneData?.row.stress_mean[selectedDateIndex];
                
                
                //tempStressValues[_zoneData?.row.zone_name] = _zoneData?.values[selectedDateIndex];
                _.set(tempStressValues, _zoneData?.row.zone_name, _zoneData?.values[selectedDateIndex]);
            })
        }
        setStressValue(tempStressValues);

        let tempVigorValues = {};
        if (zoneData && zoneData?.productivity?.dataAllZones && selectedDate) {
            zoneData.productivity.dataAllZones.forEach((_zoneData:any) => {
                console.log("C040124 _zoneData --> ", _zoneData);
                let selectedDateIndex = _zoneData?.row.productivity_date.findIndex((date:string) => date.startsWith(selectedDate));
                if (selectedDateIndex && selectedDateIndex > -1 && _zoneData?.row?.productivity_mean_transformed){
                    // tempVigorValues[_zoneData?.row.zone_name] = _zoneData?.row.productivity_mean_transformed[selectedDateIndex];
                    _.set(tempVigorValues, _zoneData?.row.zone_name, _zoneData?.row.productivity_mean_transformed[selectedDateIndex]);
                }
            })
        }
        setVigorValue(tempVigorValues);
        
        let tempVarValues = {};
        if (zoneData && zoneData?.variability?.dataAllZones && selectedDate) {
            zoneData.variability.dataAllZones.forEach((_zoneData:any) => {
                console.log("C040124 _zoneData --> ", _zoneData);
                let selectedDateIndex = _zoneData?.dates.findIndex((date:string) => date.startsWith(selectedDate));
                // tempVarValues[_zoneData?.row.zone_name] = _zoneData?.values[selectedDateIndex];
                _.set(tempVarValues, _zoneData?.row.zone_name, _zoneData?.values[selectedDateIndex]);
            })
        }
        setVarValue(tempVarValues);

        let tempChangeValues = {};
        if (zoneData && zoneData?.variability_change?.dataAllZones && selectedDate) {
            zoneData.variability_change.dataAllZones.forEach((_zoneData:any) => {
                console.log("D040124 _zoneData --> ", _zoneData);
                let selectedDateIndex = _zoneData?.dates.findIndex((date:string) => date.startsWith(selectedDate));
                // tempChangeValues[_zoneData?.row.zone_name] = _zoneData?.values[selectedDateIndex];
                _.set(tempChangeValues, _zoneData?.row.zone_name, _zoneData?.values[selectedDateIndex]);
            })
        }
        setChangeValue(tempChangeValues);

    }, [zoneData, selectedDate]);

    useEffect(() => {
        console.log("032624 zonesData", zonesData);
        if (zonesData && zonesData.length > 0) {
            console.log("Z040624 D > zonesData[selectedZoneSetIndex].properties.label", zonesData[0].properties.label);
            console.log("Z040624 D > zonesData[selectedZoneSetIndex]", zonesData[0]);
            console.log("Z040624 D > selectedZoneSetIndex", selectedZoneSetIndex);
            setSelectedZoneName(zonesData[0].properties.label)
            setUpdateSelctorIncrement(prev => prev + 1);
        }else{
            //setSelectedZoneName(null);
            //setUpdateSelctorIncrement(prev => prev + 1);
        }
    }, [zonesData]);

    useEffect(() => {
        setZones(zones);
    }, [zones]);

    useEffect(() => {
        setUpdateSelctorIncrement(prev => prev + 1);
    }, [selectedZoneName]);

    const setSelectedZone = (zone: any) => {
        console.log("Z040624 E");
        setSelectedZoneName(zone.properties.label);
    }

    return (<div
                key={`selectorparentBB__${updateSelctorIncrement}`}
                style={{
                    paddingBottom:"0px",
                    marginBottom:"10px",
                    border: "1px #e6e6e6 solid",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                    //paddingTop: "35px",
                    paddingTop:"0px",
                    paddingLeft:"0px",
                    paddingRight:"0px",
                    marginTop: "35px",
                }}
            >
                {(zonesData && zonesData.length !== 0)
                ? <>
                    <div
                        key={`selectorparent_selected_${updateSelctorIncrement}`}
                        style={{
                            paddingTop:"15px",
                            paddingBottom:"15px",
                            paddingLeft:"15px",
                            paddingRight:"15px",
                            //marginBottom:"10px",
                            borderTopLeftRadius: "4px",
                            borderTopRightRadius: "4px",
                            backgroundColor: "#fff",
                            position: "relative",
                            cursor:"pointer",
                        }}
                    >
                        {`${zones ? zones[selectedZoneSetIndex].name : ""}`}
                    </div>
                    {zonesData.map((zone: any, i:number) => {
                        //console.log("EE040624 zone", zone, i, zonesData.length)
                        if (selectedZoneName === zone.properties.label){
                            let _color = (selectedZoneName === zone.properties.label) ? "#fff" : "#000";
                            let _backgroundColor = (selectedZoneName === zone.properties.label) ? "#000" : "#fff";
                            let _lineBackgroundColor = (selectedZoneName === zone.properties.label) ? "#e6e6e6" : "#fff";
                            let _border = `1px solid #000`;
                            let _borderBottom = `${zonesData.length === (i + 1) ? "0" : "1" }px solid #e6e6e6`;
                            let _borderTop = `${1 === (i + 1) ? "1" : "0" }px solid #e6e6e6`;
                            console.log("EE040624", `div_${i}_${updateSelctorIncrement}_${zone.properties.label}_${zone.properties.zoneId}`)
                            return (
                                <div
                                    className="zone-stat-line"
                                    key={`div_${i}_${updateSelctorIncrement}_${zone.properties.label}_${zone.properties.zoneId}`}
                                    style={{
                                        width:"100%",
                                        //height: "45px",
                                        //borderBottom: _borderBottom,
                                        //borderTop: _borderTop,
                                        backgroundColor: _lineBackgroundColor,
                                        marginBottom:"0px",
                                        //border: "1px #e6e6e6 solid",
                                        //borderRadius: "4px",
                                        //backgroundColor: "#fff",
                    
                                    }}    
                                >
                                    <div
                                        key={`selector_${i}_${updateSelctorIncrement}_${zone.properties.label}`}
                                        style={{
                                            color: _color,
                                            backgroundColor: _backgroundColor,
                                            border: _border,
                                            width:"35px",
                                            height: "35px",
                                            borderRadius: "20px",
                                            fontWeight: "normal",
                                            lineHeight: "35px",
                                            textAlign: "center",
                                            cursor:"pointer",
                                            marginBottom: "0px",
                                            //borderRadius: "4px",
                                            //paddingTop: i === 0 ? "10px" : "0px",
                                        }}
                                        onClick={() => setSelectedZone(zone)}
                                    >
                                        {zone.properties.label}
                                    </div>
                                    <div className="zone-stat-stat" key={`vigor_${i}_${updateSelctorIncrement}_${zone.properties.label}`}>
                                        <div className="zone-stat-value">{vigorValue[zone.properties.label] ? dcRound(vigorValue[zone.properties.label], undefined, undefined, true) : vigorValue[zone.properties.label] === 0 ? 0 : "n/a"}</div>
                                        <div className="zone-stat-name">biomass</div>
                                    </div>
                                    <div className="zone-stat-stat" key={`stress_${i}_${updateSelctorIncrement}_${zone.properties.label}`}>
                                        <div className="zone-stat-value">{stressValue[zone.properties.label] ? dcRound(stressValue[zone.properties.label], undefined, undefined, true) : stressValue[zone.properties.label] === 0 ? 0 : "n/a"}</div>
                                        <div className="zone-stat-name">stress</div>
                                    </div>
                                    <div className="zone-stat-stat" key={`var_${i}_${updateSelctorIncrement}_${zone.properties.label}`}>
                                        <div className="zone-stat-value">{varValue[zone.properties.label] ? dcRound(varValue[zone.properties.label], undefined, undefined, true) : varValue[zone.properties.label] === 0 ? 0 : "n/a"}</div>
                                        <div className="zone-stat-name">var</div>
                                    </div>
                                    <div className="zone-stat-stat" key={`change_${i}_${updateSelctorIncrement}_${zone.properties.label}`}>
                                    <div className="zone-stat-value">{changeValue[zone.properties.label] ? dcRound(changeValue[zone.properties.label], undefined, undefined, true) : changeValue[zone.properties.label] === 0 ? 0 : "n/a"}</div>
                                        <div className="zone-stat-name">change</div>
                                    </div>
                                </div>
                            )
                        }
                            return(null);
                        })}
                    </>
                    : <div 
                        style={{
                            padding:"15px",
                            marginBottom:"0px",
                            //border: "1px #e6e6e6 solid",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
        
                        }}    
                        key={`div__${updateSelctorIncrement}_none`}>
                            No zones sets available
                        </div>   
                    }
    </div>)
}

export default ZoneManagementBBCard;